export default __webpack_public_path__ + "static/BebasNeue-Regular-9aa03f9d52866893add50e8b4912ae52.ttf";